import { render, staticRenderFns } from "./FreshChatWorkingDaysPopup.vue?vue&type=template&id=681e9d38&scoped=true"
import script from "./FreshChatWorkingDaysPopup.vue?vue&type=script&lang=js"
export * from "./FreshChatWorkingDaysPopup.vue?vue&type=script&lang=js"
import style0 from "./FreshChatWorkingDaysPopup.vue?vue&type=style&index=0&id=681e9d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681e9d38",
  null
  
)

export default component.exports